// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2073k","col":"CardReaderDesc_col__NcdBG","label":"CardReaderDesc_label__CzYrJ"};